/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntityTagHeaderValue } from './EntityTagHeaderValue';
import {
    EntityTagHeaderValueFromJSON,
    EntityTagHeaderValueFromJSONTyped,
    EntityTagHeaderValueToJSON,
    EntityTagHeaderValueToJSONTyped,
} from './EntityTagHeaderValue';

/**
 * 
 * @export
 * @interface FileStreamResult
 */
export interface FileStreamResult {
    /**
     * 
     * @type {Blob}
     * @memberof FileStreamResult
     */
    fileStream?: Blob;
    /**
     * 
     * @type {string}
     * @memberof FileStreamResult
     */
    contentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileStreamResult
     */
    fileDownloadName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FileStreamResult
     */
    lastModified?: Date | null;
    /**
     * 
     * @type {EntityTagHeaderValue}
     * @memberof FileStreamResult
     */
    entityTag?: EntityTagHeaderValue | null;
    /**
     * 
     * @type {boolean}
     * @memberof FileStreamResult
     */
    enableRangeProcessing?: boolean;
}

/**
 * Check if a given object implements the FileStreamResult interface.
 */
export function instanceOfFileStreamResult(value: object): value is FileStreamResult {
    return true;
}

export function FileStreamResultFromJSON(json: any): FileStreamResult {
    return FileStreamResultFromJSONTyped(json, false);
}

export function FileStreamResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileStreamResult {
    if (json == null) {
        return json;
    }
    return {
        
        'fileStream': json['fileStream'] == null ? undefined : json['fileStream'],
        'contentType': json['contentType'] == null ? undefined : json['contentType'],
        'fileDownloadName': json['fileDownloadName'] == null ? undefined : json['fileDownloadName'],
        'lastModified': json['lastModified'] == null ? undefined : (new Date(json['lastModified'])),
        'entityTag': json['entityTag'] == null ? undefined : EntityTagHeaderValueFromJSON(json['entityTag']),
        'enableRangeProcessing': json['enableRangeProcessing'] == null ? undefined : json['enableRangeProcessing'],
    };
}

export function FileStreamResultToJSON(json: any): FileStreamResult {
    return FileStreamResultToJSONTyped(json, false);
}

export function FileStreamResultToJSONTyped(value?: FileStreamResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileStream': value['fileStream'],
        'contentType': value['contentType'],
        'fileDownloadName': value['fileDownloadName'],
        'lastModified': value['lastModified'] == null ? value['lastModified'] : value['lastModified'].toISOString(),
        'entityTag': EntityTagHeaderValueToJSON(value['entityTag']),
        'enableRangeProcessing': value['enableRangeProcessing'],
    };
}

